// store/index.js

import Vue from "vue";
import Vuex from "vuex"; // 这行必须存在

Vue.use(Vuex); // 这行必须存在
export default new Vuex.Store({
  state: {
    token: localStorage.getItem("token") || null, // 初始化时从 localStorage 读取
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },
  },
  getters: {
    token: (state) => state.token,
  },
});
